import { Easing, interpolate, spring } from "remotion";

// ── Legacy helpers (all existing callers unchanged) ───────────────────────────

export const fadeIn = (frame: number, start: number, len = 18) =>
  interpolate(frame, [start, start + len], [0, 1], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
    easing: Easing.out(Easing.cubic),
  });

export const slideUp = (frame: number, start: number, len = 18, px = 50) =>
  interpolate(frame, [start, start + len], [px, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
    easing: Easing.out(Easing.exp),
  });

export const slideLeft = (frame: number, start: number, len = 18, px = 60) =>
  interpolate(frame, [start, start + len], [px, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
    easing: Easing.out(Easing.exp),
  });

export const scaleIn = (frame: number, start: number, len = 14) =>
  interpolate(frame, [start, start + len], [0.85, 1], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
    easing: Easing.out(Easing.elastic(1)),
  });

export const countUp = (frame: number, start: number, len: number, to: number) =>
  Math.round(interpolate(frame, [start, start + len], [0, to], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
    easing: Easing.out(Easing.cubic),
  }));

export const progressBar = (frame: number, total: number) =>
  interpolate(frame, [0, total], [0, 100], { extrapolateRight: "clamp" });

export const fillBar = (frame: number, start: number, len: number, to: number) =>
  interpolate(frame, [start, start + len], [0, to], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
    easing: Easing.out(Easing.cubic),
  });

// ── Spring physics (more natural, bouncy feel) ────────────────────────────────

export const springVal = (
  frame: number,
  fps: number,
  delay = 0,
  config?: { stiffness?: number; damping?: number; mass?: number }
) =>
  spring({
    frame: Math.max(0, frame - delay),
    fps,
    config: { stiffness: 120, damping: 14, mass: 1, ...config },
  });

export const springFade = (frame: number, fps: number, delay = 0) =>
  Math.min(1, springVal(frame, fps, delay, { stiffness: 80, damping: 18 }));

export const springScale = (frame: number, fps: number, delay = 0, from = 0.8) => {
  const s = springVal(frame, fps, delay, { stiffness: 200, damping: 16 });
  return from + s * (1 - from);
};

export const springSlideUp = (frame: number, fps: number, delay = 0, px = 60) => {
  const s = springVal(frame, fps, delay, { stiffness: 100, damping: 12 });
  return px - s * px;
};

export const springSlideLeft = (frame: number, fps: number, delay = 0, px = 60) => {
  const s = springVal(frame, fps, delay, { stiffness: 100, damping: 12 });
  return px - s * px;
};

export const springBounce = (frame: number, fps: number, delay = 0) =>
  springVal(frame, fps, delay, { stiffness: 300, damping: 10, mass: 0.5 });

// ── Kinetic text — word-by-word staggered reveal ──────────────────────────────

export const splitWords = (text: string): string[] => text.split(/\s+/);

export interface WordReveal {
  opacity: number;
  translateY: number;
  scale: number;
}

export const kineticWord = (
  frame: number,
  fps: number,
  wordIndex: number,
  stagger = 3
): WordReveal => {
  const delay = wordIndex * stagger;
  const s = springVal(frame, fps, delay, { stiffness: 180, damping: 16 });
  return {
    opacity: Math.min(1, s * 2),
    translateY: 40 - s * 40,
    scale: 0.8 + s * 0.2,
  };
};

// ── Ken Burns — slow zoom/pan on static images ────────────────────────────────

export const kenBurnsScale = (
  frame: number,
  totalFrames: number,
  zoom = 1.08,
  direction: "in" | "out" = "in"
) =>
  direction === "out"
    ? interpolate(frame, [0, totalFrames], [zoom, 1], { extrapolateRight: "clamp", easing: Easing.inOut(Easing.quad) })
    : interpolate(frame, [0, totalFrames], [1, zoom], { extrapolateRight: "clamp", easing: Easing.inOut(Easing.quad) });

export const kenBurnsPan = (frame: number, totalFrames: number, px: number) =>
  interpolate(frame, [0, totalFrames], [0, px], {
    extrapolateRight: "clamp",
    easing: Easing.inOut(Easing.quad),
  });

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
